import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="StepBox" :class="{ 'StepBox--active': isactive, 'StepBox--selected': iscurrent, 'StepBox--sticky': stickyclass }, [ 'StepBox--' + step ]" >
            <div class="StepBox__wrap">
                <div class="StepBox__header">
                    <div v-if="step" class="StepBox__stepnumber">
                        {{ step }}
                    </div>

                    <div v-if="title" class="StepBox__title">{{ title }}</div>

                    <template v-if="step < currentstep">
                        <button  type="button" class="StepBox__edit" @click="$emit('edit')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4898 1.44539C19.7504 0.184868 21.7941 0.18487 23.0546 1.4454C24.3151 2.70592 24.3151 4.74964 23.0546 6.01017L12.4887 16.5761C12.4689 16.5958 12.4494 16.6154 12.4301 16.6347C12.1053 16.9599 11.8435 17.2221 11.5292 17.4147C11.2524 17.5843 10.9506 17.7093 10.635 17.7851C10.2765 17.8711 9.90601 17.8709 9.44637 17.8706C9.41908 17.8706 9.39147 17.8706 9.36354 17.8706H7.51333C7.02515 17.8706 6.6294 17.4748 6.6294 16.9866V15.1365C6.6294 15.1085 6.62938 15.0809 6.62937 15.0536C6.62907 14.594 6.62883 14.2235 6.71488 13.865C6.79067 13.5494 6.91567 13.2476 7.0853 12.9708C7.2779 12.6565 7.54007 12.3947 7.86529 12.0699C7.8846 12.0506 7.90413 12.0311 7.92388 12.0113L18.4898 1.44539ZM21.8045 2.69545C21.2344 2.12531 20.31 2.12531 19.7399 2.69545L9.17394 13.2614C8.762 13.6733 8.66191 13.7814 8.59263 13.8945C8.51994 14.0131 8.46636 14.1425 8.43388 14.2777C8.40293 14.4067 8.39725 14.5539 8.39725 15.1365V16.1027H9.36354C9.94611 16.1027 10.0933 16.097 10.2223 16.0661C10.3575 16.0336 10.4869 15.98 10.6055 15.9073C10.7186 15.8381 10.8267 15.738 11.2386 15.326L21.8045 4.76011C22.3747 4.18997 22.3747 3.26559 21.8045 2.69545ZM6.14991 2.84386L10.8281 2.84386C11.3162 2.84386 11.712 3.23961 11.712 3.72778C11.712 4.21596 11.3162 4.61171 10.8281 4.61171H6.18747C5.24468 4.61171 4.59074 4.61239 4.08235 4.65393C3.58428 4.69463 3.30423 4.77008 3.09508 4.87665C2.6377 5.1097 2.26584 5.48156 2.03279 5.93894C1.92622 6.14809 1.85077 6.42814 1.81007 6.92621C1.76854 7.4346 1.76785 8.08853 1.76785 9.03133V18.3125C1.76785 19.2553 1.76854 19.9093 1.81007 20.4177C1.85077 20.9157 1.92622 21.1958 2.03279 21.4049C2.26584 21.8623 2.6377 22.2342 3.09508 22.4672C3.30424 22.5738 3.58428 22.6492 4.08235 22.6899C4.59074 22.7315 5.24468 22.7321 6.18747 22.7321H15.4687C16.4115 22.7321 17.0654 22.7315 17.5738 22.6899C18.0719 22.6492 18.3519 22.5738 18.5611 22.4672C19.0184 22.2342 19.3903 21.8623 19.6234 21.4049C19.7299 21.1958 19.8054 20.9157 19.8461 20.4177C19.8876 19.9093 19.8883 19.2553 19.8883 18.3125V13.6719C19.8883 13.1838 20.284 12.788 20.7722 12.788C21.2604 12.788 21.6561 13.1838 21.6561 13.6719V18.3501C21.6562 19.2464 21.6562 19.9727 21.608 20.5616C21.5584 21.169 21.4532 21.7076 21.1985 22.2075C20.796 22.9975 20.1537 23.6398 19.3636 24.0424C18.8637 24.2971 18.3251 24.4023 17.7178 24.4519C17.1289 24.5 16.4026 24.5 15.5063 24.5H6.14988C5.25357 24.5 4.52726 24.5 3.93839 24.4519C3.33099 24.4023 2.7924 24.2971 2.2925 24.0424C1.50247 23.6398 0.860163 22.9975 0.457625 22.2075C0.20291 21.7076 0.0977228 21.169 0.0480963 20.5616C-1.65994e-05 19.9727 -9.11736e-06 19.2464 2.6074e-07 18.3501V8.99376C-9.11736e-06 8.09744 -1.65994e-05 7.37112 0.0480963 6.78225C0.0977228 6.17485 0.20291 5.63626 0.457625 5.13636C0.860163 4.34633 1.50247 3.70402 2.2925 3.30148C2.7924 3.04677 3.33099 2.94158 3.93839 2.89195C4.52727 2.84384 5.25358 2.84385 6.14991 2.84386Z" fill="#2F4858"/>
                            </svg>
                        </button>
                    </template>

                    <template v-if="visible_edit2 && step >= currentstep">
                        <button type="button" class="StepBox__edit2" @click="$emit('edit2')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M1.7002 4.3702V19.6302C1.7002 21.1002 2.9002 22.3002 4.3702 22.3002H19.6302C21.1002 22.3002 22.3002 21.1002 22.3002 19.6302V9.9802C22.3002 9.54019 21.9402 9.1802 21.5002 9.1802C21.0602 9.1802 20.7002 9.54019 20.7002 9.9802V19.6302C20.7002 20.2202 20.2202 20.7002 19.6302 20.7002H4.3702C3.7802 20.7002 3.3002 20.2202 3.3002 19.6302V4.3702C3.3002 3.7802 3.7802 3.3002 4.3702 3.3002H13.7002C14.1402 3.3002 14.5002 2.9402 14.5002 2.5002C14.5002 2.0602 14.1402 1.7002 13.7002 1.7002H4.3702C2.9002 1.7002 1.7002 2.9002 1.7002 4.3702Z" fill="#B1B1B1"/>
                                <path d="M10.3504 15.2901C9.94043 15.7001 9.39043 15.9301 8.82043 15.9301L7.31043 15.9501C6.84043 15.9501 6.39043 16.1401 6.06043 16.4701L5.11043 17.4201C4.80043 17.7301 4.80043 18.2401 5.11043 18.5501C5.27043 18.7101 5.47043 18.7801 5.68043 18.7801C5.89043 18.7801 6.09043 18.7001 6.25043 18.5501L7.20043 17.6001C7.20043 17.6001 7.28043 17.5501 7.33043 17.5501L8.84043 17.5301C9.84043 17.5301 10.7804 17.1301 11.4904 16.4201L19.3204 8.59008L21.5604 6.35008C21.8604 6.05008 22.0304 5.64008 22.0304 5.22008C22.0304 4.80008 21.8604 4.39008 21.5604 4.08008L19.6404 2.17008C19.0204 1.55008 18.0004 1.55008 17.3804 2.17008L15.0404 4.51008L7.29043 12.2601C6.69043 12.8601 6.31043 13.6501 6.21043 14.4801C6.16043 14.9201 6.47043 15.3201 6.91043 15.3701C6.94043 15.3701 6.98043 15.3701 7.01043 15.3701C7.41043 15.3701 7.75043 15.0701 7.80043 14.6701C7.86043 14.1901 8.08043 13.7301 8.43043 13.3801L15.7104 6.10008L17.6304 8.02008L10.3704 15.2801L10.3504 15.2901ZM18.5004 3.30008L20.4204 5.22008L18.7504 6.89008L16.8304 4.97008L18.5004 3.30008Z" fill="#B1B1B1"/>
                            </svg>
                        </button>
                    </template>
                </div>

                <template v-if="iscurrent">
                    <hr v-if="title">

                    <div class="StepBox__body">
                        <slot></slot>
                    </div>

                    <div v-if="error" class="StepBox__error" v-html="error"></div>

                    <div ref="footer" class="StepBox__footer">
                        <div class="StepBox__footer-inner">
                            <button v-if="back" type="button" class="button button--back" @click="$emit('back')">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5401 20L11.4599 19.0801L2.37983 10L11.4599 0.919888L10.5401 0L0.540054 10L10.5401 20Z" fill="#005537"/>
                                </svg>
                            </button>

                            <button type="button" class="button button--primary" @click="$emit('next')" :disabled="!valid">{{ label_next }}</button>
                        </div>
                    </div>

                    <slot name="footer"></slot>
                </template>
            </div>
        </div>
    `,

    emits: [
        'next',
        'back',
        'edit',
        'edit2',
    ],

    props: {
        step: { type: Number },
        currentstep: { type: Number },
        title: { type: String },

        error: { type: String },

        sticky: { type: String },

        back: { type: Boolean, default: true },
        valid: { type: Boolean },

        label_next: { type: String, default: 'Dalej' },

        visible_edit2: { type: Boolean, default: false },
    },

    data() {
        return {
            stickyclass: false,
        };
    },

    computed: {
        isactive() {
            return this.step <= this.currentstep;
        },

        iscurrent() {
            return this.step == this.currentstep;
        },
    },

    mounted() {
        $(document).on('scroll', () => {
            this.recalc();
        });

        $(window).on('resize', () => {
            this.recalc();
        });

        this.recalc();
    },

    methods: {
        recalc() {
            const st = $(document).scrollTop();

            if (this.sticky && this.$refs.footer) {
                const $footer = $(this.$refs.footer);
                const top = $footer.offset().top;
                const wh = window.innerHeight;

                this.stickyclass = st + wh < top;
            } else {
                this.stickyclass = false;
            }
        },
    },
});
